import { render, staticRenderFns } from "./m-gc-step-package.vue?vue&type=template&id=50b91763&scoped=true&"
import script from "./m-gc-step-package.vue?vue&type=script&lang=js&"
export * from "./m-gc-step-package.vue?vue&type=script&lang=js&"
import style0 from "./m-gc-step-package.vue?vue&type=style&index=0&id=50b91763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b91763",
  null
  
)

export default component.exports